export class UpdateProjectRequest
{
    public programId: string;
    public name: string;
    public description: string;
    public isActive: boolean = true;
    public cap: string;
    public spa: File | null;
    public source: string | "catalog";
}
